"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flex = void 0;
const flex = ({ inline = false, wrap = true, horizontal = true, reverse = false, verticalAlignment, horizontalAlignment, direction, gap, flexGrow, alignItems, justifyContent, alignSelf, }) => {
    return `
    display: ${inline ? 'inline-flex' : 'flex'};
    flex-wrap: ${wrap ? 'wrap' : 'nowrap'};
    flex-direction: ${horizontal
        ? `row${reverse ? '-reverse' : ''}`
        : `column${reverse ? '-reverse' : ''}`};
    ${gap
        ? `
      gap: ${gap}px;
      @supports (-webkit-touch-callout: none) and (not (translate: none)) {
        &:not(:last-child) {
          ${direction === 'column'
            ? `margin-right: ${gap};`
            : `margin-bottom: ${gap};`}
        };
      };
    `
        : ''}
    ${horizontalAlignment
        ? horizontal
            ? `
          justify-content: ${horizontalAlignment};
        `
            : `
          align-items: ${horizontalAlignment};
        `
        : ''}

    ${verticalAlignment
        ? horizontal
            ? `
          align-items: ${verticalAlignment};
        `
            : `
          justify-content: ${verticalAlignment};
        `
        : ''}

    ${flexGrow ? `flex-grow: ${flexGrow};` : ''}
    ${alignItems ? `align-items: ${alignItems};` : ''}
    ${justifyContent ? `justify-content: ${justifyContent};` : ''}
    ${alignSelf ? `align-self: ${alignSelf};` : ''}
  `;
};
exports.flex = flex;
